import { initializeApp } from "firebase/app";
import { FirebaseMessaging } from "@capacitor-firebase/messaging";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAv2gmZYl03K-EsNmKwOF0rNhO1YMrvj5Q",
  authDomain: "hisocialize-e0aee.firebaseapp.com",
  projectId: "hisocialize-e0aee",
  storageBucket: "hisocialize-e0aee.firebasestorage.app",
  messagingSenderId: "345684887027",
  appId: "1:345684887027:web:61ed0944ee4b116791be86"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Solicitar permisos para notificaciones
export const requestPermissions = async () => {
  await FirebaseMessaging.requestPermissions();
};

// Obtener el token FCM
export const getFCMToken = async () => {
  console.log("FCM Tofdsgrsdgfthrtshtdfsvfsdfrken:");
  const { token } = await FirebaseMessaging.getToken();
  console.log("FCM Token:", token);
  return token; // Devuelve el token para enviarlo al backend
};

// Escuchar notificaciones en primer plano
export const setupForegroundNotifications = () => {
  FirebaseMessaging.addListener("notificationReceived", (event) => {
    console.log("Notificación recibida:", event);
    // Aquí puedes manejar la notificación (por ejemplo, mostrar un alert)
  });
};


export default app;